import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.WorkflowSettingsPopupContent.SectionDecisionPolicy', {
    title: 'Approval decision policy',
    subtitle:
        'If an Approver has been added to more than one step in the request and approves it, this approval should be applied to:',
    allStepLabel: 'All steps at once',
    currentStepLabel: 'Only to the current step',
});
